module.exports = __webpack_public_path__ + "img/180-french-polynesia.4d1fbde1.svg";